import redImage from '../assets/red.jpg'
import blueImage from '../assets/plain.jpg'
import greenImage from '../assets/green.jpg'

export const productList= [
    {
        "src": blueImage,
        "title":"Cubeplex - blue",
        "id":'price_1LT82ABGz49829C1cXeiGmP7',
        "referance_price":'14.99'
      },
      {
        "src": redImage,
        "title":"Cubeplex - red",
        "id":'price_1LT82nBGz49829C1RDOqdVMK',
        "referance_price":'14.99'
      },
      {
        "src": greenImage,
        "title":"Cubeplex - green",
        "id":'price_1LT82WBGz49829C1gtPKMrEU',
        "referance_price":'14.99'
      },
      
]